import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { appConstant, apiUrl } from '@constants';

import Selectors from '../selectors';
import Actions from '../action';
import LoginPresentational from './login-presentational';

import SelectorsApp from '@sharedComponent/app-action-reducer/selectors';
import { encryptCompanyId } from '@helpers';

const LoginFunctional = ({ loginLoading, login, history, loginSuccess, userDetails }) => {
	const [clientData, setclientData] = useState(null);
	const [encryptComId, setEncryptId] = useState('');
	useEffect(() => {
		fetch('https://geoip-db.com/json/')
			.then((res) => res.json())
			.then((json) => setclientData(json));
		getEncryptComId(745)
		if (userDetails) {
			history.push('/dashboard');
		}
	}, []);
	const getEncryptComId = async (id) => {
		let encryptId = await encryptCompanyId(id)
		setEncryptId(encryptId)
	};
	const goToSignUp = () => {
		history.push(`/register/${encryptComId}`);
	};

	const goToForgot = () => {
		history.push('/forgot-password');
	};

	const onFinish = (request) => {
		// login({ ...request, userName: request.userName.replace(/\s+/g, ''), ipAddress: clientData.IPv4 }, history);
		login({ ...request, userName: request.userName, ipAddress: clientData.IPv4 }, history);
	};

	return (
		<LoginPresentational
			loginSuccess={loginSuccess}
			onFinish={onFinish}
			goToSignUp={goToSignUp}
			goToForgot={goToForgot}
			login={login}
			loginLoading={loginLoading}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		loginLoading: Selectors.loginValue(state),
		loginSuccess: Selectors.loginSuccess(state),
		userDetails: SelectorsApp.userDetails(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		login: (request, history) => dispatch(Actions.creators.login(request, history)),
		resetValues: () => dispatch(Actions.creators.resetValues()),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(LoginFunctional);

export default Connected;
